/**
 * Drag-to-reorder for an adoption listing's photos.
 *
 * `sort_order` was insertion order with no way to change it, so the only lever
 * an owner had was to delete a photo and upload it again.
 *
 * Saved over fetch rather than by submitting a form, because the gallery sits
 * inside the edit page: a reload after every drag would throw away whatever
 * has been typed into the fields above it and not yet saved.
 *
 * The move buttons are not a nicety. Native drag and drop does nothing on a
 * touch screen and nothing from a keyboard, so without them this feature only
 * exists for one kind of visitor to the admin.
 */
export function registerPhotoReorder(Alpine) {
    Alpine.data('photoReorder', (photos = [], config = {}) => ({
        photos,
        from: null,
        status: 'idle',

        start(index) {
            this.from = index;
        },

        /** Live reorder while dragging, so the grid shows the result, not a ghost. */
        over(index) {
            if (this.from === null || this.from === index) return;

            this.photos.splice(index, 0, this.photos.splice(this.from, 1)[0]);
            this.from = index;
        },

        end() {
            if (this.from === null) return;

            this.from = null;
            this.save();
        },

        move(index, delta) {
            const to = index + delta;

            if (to < 0 || to >= this.photos.length) return;

            this.photos.splice(to, 0, this.photos.splice(index, 1)[0]);
            this.save();
        },

        async save() {
            this.status = 'saving';

            try {
                const response = await fetch(config.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content ?? '',
                    },
                    body: JSON.stringify({ order: this.photos.map((p) => p.id) }),
                });

                this.status = response.ok ? 'saved' : 'failed';
            } catch {
                this.status = 'failed';
            }
        },
    }));
}
